module.exports = __webpack_public_path__ + "static/img/y35.a624bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y35.jpg
// module id = UXY5
// module chunks = 1